import type { TuidVerifyQuestion } from '../types';

const sortQuestions = (questions: TuidVerifyQuestion[]): TuidVerifyQuestion[] =>
  [...questions]
    .sort((a, b) => parseFloat(a.sequenceNumber) - parseFloat(b.sequenceNumber))
    .map((q) => ({
      ...q,
      answerChoices: [...(q.answerChoices ?? [])].sort(
        (a, b) => parseFloat(a.sequenceNumber) - parseFloat(b.sequenceNumber),
      ),
    }));

export default sortQuestions;
